export default function Status(props) {
	return <span id="a11y-status">{props.children}</span>;
}
